import request from '@/utils/request'
// 验证码登录/注册
export function login(data) {
  console.log('data==', data)
  return request({
    url: '/api/login',
    method: 'post',
    data
  })
}

// 发送验证码接口
export function getCode(data) {
  return request({
    url: '/api/code/'+data,
    method: 'get'
  })
}

// 获取用户信息
export function getInfo(data) {
  return request({
    url: '/api/info',
    method: 'get',
    params:data
  })
}

// 字典接口
export function getDict(data) {
  return request({
    url: '/api/dict',
    method: 'get',
    params:data
  })
}

// 获取基础科室列表
export function getBaseDepts() {
  return request({
    url: '/api/dept/getBaseDepts',
    method: 'get'
  })
}

//退出登录
export function logout(data) {
  return request({
    url: '/api/logout',
    method: 'post',
    data
  })
}
